<template>
  <div>
    <div v-show="!showUpdate" class="app-content content ">
      <div class="content-overlay"></div>
      <div class="header-navbar-shadow"></div>
      <div class="content-wrapper">
        <div class="content-header row">
          <div class="content-header-left col-md-9 col-12 mb-2">
            <Breadcrumb
                name="Features"
                bc1="App"
                bc2="Features"
                bc3="List"
            ></Breadcrumb>
          </div>
          <div
              class="content-header-right text-md-right col-md-3 col-12 d-md-block d-none"
          >

          </div>
        </div>
        <div class="content-body">
          <div class="card">
            <div class="m-2">
              <div class="row">
                <div class="col-md-12 col-12 ">
                  <div
                      class="d-flex align-items-center justify-content-end d-flex"
                  >
                    <div class="col-sm-4">
                      <select class="form-control"  v-model="recordStatus">
                        <option
                            v-for="(item, index) in recordStatusOptions"
                            :key="index"
                            :value="item.id"
                        >{{ item.value }}</option
                        >
                      </select>

                    </div>
                    <div class="col-sm-2">
                      <select class="form-control"  v-model="type">
                        <option
                            v-for="(item, index) in options"
                            :key="index"
                            :value="item.id"
                        >{{ item.value }}</option
                        >
                      </select>

                    </div>
                    <!--                  <button-->
                    <!--                    type="button"-->
                    <!--                    class="btn btn-primary d-flex"-->
                    <!--                    @click="$router.push({ name: 'features-add' })"-->
                    <!--                  >-->
                    <!--                    <span class="text-nowrap">Add Record</span>-->
                    <!--                  </button>-->
                  </div>
                </div>
              </div>
            </div>

            <!--:data="data"-->
            <CommonTableStore
                v-if="renderComponent"
                ref="commonTable"
                :url="url"
                :filteredData="filteredData"
                :tableHeaderValues="tableHeaderValues"
                :actions="actions"
                :deleteActions="deleteActions"
                :mutedData="mutedData"
                :storageKey="storageKey"
                :externalTotalRecord="externalTotalRecord"
                :showPerPage = true
            />
          </div>
        </div>
      </div>
    </div>
    <UpdateFeatures @back="showUpdate = false" v-if="showUpdate" />
  </div>
</template>

<script>
import { CommandIcon } from "vue-feather-icons";
import UpdateFeatures from "@/pages/dashboard/features/UpdateFeatures.vue";
import UpdateSettings from "@/pages/dashboard/settings/UpdateSettings.vue";

export default {
  components: {UpdateSettings, CommandIcon, UpdateFeatures },
  data() {
    return {
      url: "v1/get-feature",
      storageKey: "features",
      renderComponent: true,
      showUpdate:false,
      type: 1,
      recordStatus: 1,
      data: { flag: "all", type: 1 },
      /*todo*/
      filteredData: {type: 1,status: 1},
      recordStatusOptions: [
        { id: 0, value: "Inactive" },
        { id: 1, value: "Active For All" },
        { id: 2, value: "Active For Mobile Only" },
        { id: 3, value: "Active For Web Only" }
      ],
      options: [
        { id: 1, value: "Admin" },
        { id: 2, value: "User" },
        { id: 3, value: "Merchant" }
      ],
      tableHeaderValues: [
        {
          title: "Name",
          valueKey: "name"
        },
        {
          title: "Type",
          valueKey: "type",
          html: true,
          alter: function(value) {
            var html = "";
            if (value == 1) {
              html = "Admin";
            } else if (value == 2) {
              html = "User";
            } else {
              html = "Merchant";
            }
            return html;
          }
        },
        {
          title: "Status",
          valueKey: "status",
          html: true,
          alter: function(value, row) {
            var html = "";
            if (value == 1) {
              html = `<span class="badge badge-light-success badge-sm">Active For All</span>`;
            } else if(value == 2) {
              html = `<span class="badge badge-light-info badge-sm">Active For Web Only</span>`;
            }
            else if(value == 3) {
              html = `<span class="badge badge-light-primary badge-sm">Active For Mobile Only</span>`;
            }else{
              html = `<span class="badge badge-light-danger badge-sm">Inactive</span>`;
            }


            return html;
          }
        }
      ],
      actions: [
        {
          title: "Update",
          cta: (row, index) => {
            let data = {
              ...row,
              index: index,
              row: row,
              key: "featuresUpdate",
              storageKey: this.storageKey,
              idx: index,
            }
            this.$store.dispatch("set", data);
            this.showUpdate = true
          }
        }
      ],
      deleteActions: [
        // {
        //   title: "Delete",
        //   class: " ml-1 custom-control-primary",
        //   cta: (row, index) => {
        //     let data = {
        //       index: index,
        //       row: row,
        //       key: "featureDelete"
        //     };
        //     this.deleteRecord(data);
        //   }
        // }
      ],
      mutedData: [],
      externalTotalRecord: ""
    };
  },
  created() {},
  mounted() {
      localStorage.setItem("url", "v1/get-feature");
      this.checkDataInStore('v1/get-feature')
      if (
          typeof this.$route.params.update == "undefined" &&
          typeof this.$route.params.add == "undefined"
      ) {
          this.$store.dispatch("set", null);
      }
  },

  methods: {
    typeChange() {
      this.filteredData = {
        flag: "all",
        type: this.type
      };
    },
    deleteRecord(data) {
      this.makeRequest("post", "v1/delete-feature", {
        status: data.row.status == true ? 1 : 0,
        id: data.row.id
      }).then(callResponse => {
        if (!callResponse.error) {
          let code = callResponse.response.data.code;
          if (code == 200) {
            let storeData = this.$store.getters.getByKey("features");
            if (storeData != null) {
              if (typeof storeData.firstPageData != "undefined") {
                if (
                  typeof storeData.firstPageData.data[data.index] != "undefined"
                ) {
                  if (
                    storeData.firstPageData.data[data.index].id == data.row.id
                  ) {
                    storeData.firstPageData.data[data.index] = data.row;
                    delete storeData.otherPageData;
                  }
                }
              }
              if (typeof storeData.otherPageData != "undefined") {
                if (
                  typeof storeData.otherPageData.data[data.index] != "undefined"
                ) {
                  if (
                    storeData.otherPageData.data[data.index].id == data.row.id
                  ) {
                    storeData.otherPageData.data[data.index] = data.row;
                  }
                }
              }
              storeData.key = "features";
              this.$store.dispatch("set", storeData);
            }
          }
        }
      });
    }
  },
  watch:{
    type(val){
      let temp = this.filteredData
      temp.type = val
      this.filteredData = JSON.parse(JSON.stringify(temp))
    },
    recordStatus(val){
      let temp = this.filteredData
      temp.status = val
      this.filteredData = JSON.parse(JSON.stringify(temp))
    }
  }
};
</script>
